import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import envVars from '../../../constants/envVars';
import { rmaRequest } from './queryKeys';
const useSetRmaPickup = () => {
    const queryClient = useQueryClient();
    const params = useQueryRequestParams();
    return useMutation({
        mutationFn: async (attributes) => await axios.post(`${envVars.API_COMMERCE_HOSTNAME}rma/create-return-label/`, attributes, params),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [rmaRequest]
            });
        }
    });
};
export default useSetRmaPickup;
